import { fortnoxAuthService } from '@/services/auth/fortnox-auth-service';
import { computed } from 'vue';

export function useFortnoxAuth() {
  const state = fortnoxAuthService.authState;

  const authenticated = computed(() => {
    return Boolean(state.refreshToken);
  });
  const me = computed(() => state.me);
  const isAdmin = computed(() => false);
  const loading = computed(() => state.loading === true);
  const login = () => fortnoxAuthService.login();
  const logout = () => fortnoxAuthService.logout();

  return {
    authenticated,
    me,
    isAdmin,
    loading,
    login,
    logout,
  };
}
